 import React from 'react';
import '../styles/workexperience.css';
import { motion } from 'framer-motion';



const points = [
  'Supervised business relations with over 300+ suppliers with local and international markets, managed US $7 Million in total expenditure, US $3.0 Million in Capex spending and US $4.0 Million in Opex spending.',
  'Examined spending, developed data-driven actions to reduce risks, and ensure critical monitoring.',
  'Initiated targeted cost-saving programs and scrutinised day-to-day business practices for various categories of spend.',
  'Mentored and taught 4 direct reportees and supervised quarterly KPI reviews and professional development for functional buyers.',
  'Managed successful business relationships with 300+ merchants and manufacturers.',
  'Spearheading global procurement integration and alignment for North America and Israel units.',
  'Streamlined the entire procure-to-pay process in 18 months, reducing administrative time and effort in requisition, creation, and supplier payments.',
  'Team member in spearheading development and implementation of spend analytics and dashboard development.',
];

const WorkExperience = () => {
  return (
    <section className="work-section">
      <motion.div
         className="work-left"
        initial={{ y: -50, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        <h2 className="section-heading">
          Work Experience
          <span className="underline"></span>
        </h2>
      </motion.div>

      <motion.div
           className="work-left"
        initial={{ y: -50, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        <div className="grid-points">
          {points.map((point, index) => {
            // const isMobile = window.innerWidth <= 768;
            // const fromLeft = isMobile ? index % 2 === 0 : index < 4;
            const animationProps = {
              initial: { y: 100, opacity: 0 }, // 👉 from bottom
              whileInView: { y: 0, opacity: 1 },
              transition: { duration: 0.6, delay: index * 0.1 },
              viewport: { once: true },
            };

            return (
              <motion.div className="point-box" key={index} {...animationProps}>
                <p>• {point}</p>
              </motion.div>
            );
          })}
        </div>
      </motion.div>
    </section>
  );
};

export default WorkExperience;